<template>
    <div class="vh-navbar-fixed">
        <div class="vh-container vh-container-large">
            <nav class="vh-navbar">
                <div class="vh-navbar-left">
                    <a class="vh-navbar-item vh-link-reset">
                        <img src="/static/assets/img/vh-emblem-primary.svg" height="60px" width="60px">
                    </a>
                </div>

                <div class="vh-navbar-right" v-if="isActive">
                    <ul class="vh-navbar-nav" v-if="!loading">
                        <li class="vh-active">
                            <a @click="show = !show">
                                <vh-avatar
                                    :shape="'circle'"
                                    :src="accessUser.photo"
                                    :label="initials" />
                                <span class="vh-margin-small-left vh-visible@m">
                                    {{fullName}}
                                </span>
                            </a>
                            <div class="vh-navbar-dropdown vh-dropdown-nav vh-navbar-dropdown-right vh-box-shadow-small vh-padding-remove vh-animate vh-animate-fade-in"
                                :class="openClass"
                                v-show="show">

                                <ul class="vh-list">
                                    <li>
                                        <a class="vh-link-reset vh-text-muted" @click="submit()">
                                            <div class="vh-padding-small">
                                                <p>
                                                    <i class="fa fa-lock vh-margin-xsmall-right"></i>
                                                    Sign out
                                                </p>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                    <div class="vh-loader vh-loader-large vh-margin-small-bottom" v-else></div>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { Text } from '@/utils';

export default
{
    data()
    {
        return {
            show: false,

            loading: false,
        };
    },

    computed:
    {
        ...mapGetters({
            accessUser: 'auth/accessUser',
            isActive: 'auth/isActive',
        }),

        initials()
        {
            return Text.initials(
                this.accessUser.firstname,
                this.accessUser.lastname
            );
        },

        fullName()
        {
            return `${this.accessUser.firstname}
                    ${this.accessUser.lastname}`;
        },

        openClass()
        {
            return {
                'vh-open': this.show
            };
        },
    },

    methods:
    {
        ...mapActions({
            signout: 'auth/signout',
        }),

        async submit()
        {
            this.show = false;

            this.loading = true;

            const response = await this.signout();

            if (response.status === 200) window.location.href = process.env.APP_URL;

            this.loading = false;
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/views/layouts/navbar.vue